import { PhotovoltaicStringModel, PhotovoltaicTrackerModel } from '../models/photovoltaic'

export const DEFAULT_PHOTOVOLTAIC_STRING_DATA: Readonly<PhotovoltaicStringModel> = {
  pvModuleType: '',
  moduleCount: null,
  powerOptimizer: '',
  direction: '',
  orientation: null,
  testVoltage: null,
  modulePeakPower: null,
  openCircuitVoltage: null,
  positiveElectrodeGround: null,
  negativeElectrodeGround: null,
  riso: null,
  kwp: null,
}

export const DEFAULT_PHOTOVOLTAIC_TRACKER_DATA = (): Readonly<PhotovoltaicTrackerModel> => ({
  name: '',
  pvStrings: [DEFAULT_PHOTOVOLTAIC_STRING_DATA],
  appliedToAllString: true,
})

export type PhotovoltaicFormData = { pvTrackers: PhotovoltaicTrackerModel[] }
export const DEFAULT_PHOTOVOLTAIC_DATA: PhotovoltaicFormData = {
  pvTrackers: [DEFAULT_PHOTOVOLTAIC_TRACKER_DATA()],
}

export type InProgressPhotovoltaicValidation = {
  pvTrackers: Partial<InProgressPhotovoltaicTrackerValidation>[]
}
export interface InProgressPhotovoltaicTrackerValidation extends Omit<PhotovoltaicTrackerModel, 'pvStrings'> {
  pvStrings: Partial<PhotovoltaicStringModel>[]
}
